import { useEffect, useCallback } from 'react';
import { useRoles } from '@/Recoil/Topik/Roles';
import RoleTable from './RoleTable';

const StudentTable = () => {
    const { roles, byRole, loading, syncUsersByRole, assignUserRole, removeUserRole } = useRoles();

    useEffect(() => {
        syncUsersByRole({ role: 'student' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const users = byRole.student.map(email => roles[email]).filter(Boolean);

    const handleAdd = useCallback(async (email: string) => {
        await assignUserRole({ email, role: 'student' });
    }, [assignUserRole]);

    const handleRemove = useCallback(async (email: string) => {
        await removeUserRole({ email });
    }, [removeUserRole]);

    return (
        <RoleTable
            role="student"
            users={users}
            loading={loading}
            onAdd={handleAdd}
            onRemove={handleRemove}
        />
    );
};

export default StudentTable;
